module.exports = __webpack_public_path__ + "static/phone-be2fcb008549548e6c51a439a1dec6d6.jpeg";